export const ASCEND = "ascend";
export const DECEND = "descend";

export const SORT_DIRECTIONS = [ASCEND, DECEND, ASCEND];
